import { IconButton, Spacer, SvgDownload } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import {
  DESKTOP_MIN_WIDTH,
  LARGE_TABLET_MIN_WIDTH,
  SMALL_DESKTOP_MAX_WIDTH,
} from 'constants/breakpoints';
import { DOWNLOAD } from 'constants/menuOptions';
import { startDownload } from 'creators/header';

import OverflowMenu from '../overflow-menu';
import ShareButtonsWrapper from '../share-buttons';
import ViewerInsightsButton from '../viewer-insights/button';
import ViewerInsightsForNonEditors from '../viewer-insights/simple';

import HeaderPortal from 'components/layout/header/portal';
import MediaQuery from 'components/media-query';

import styles from './styles.module.less';

export default ({
  downloadUrl,
  triggerFocusTitle,
  user,
  video,
  currentUserIsOwner,
  videoIsTeamShared,
  isLoggedIn,
}) => {
  const dispatch = useDispatch();

  const downloadName = `${video.name || video.id}.mp4`;

  const downloadVideo = () => {
    dispatch(
      startDownload({
        url: downloadUrl,
        name: downloadName,
        opts: {
          video_id: video.id,
          is_owner: video.current_user_is_owner,
        },
      })
    );
  };

  const downloadProps = {
    altText: DOWNLOAD,
    icon: <SvgDownload />,
    onClick: downloadVideo,
    isDisabled: !downloadUrl,
  };

  return (
    <HeaderPortal>
      <MediaQuery query={`(min-width: ${LARGE_TABLET_MIN_WIDTH}px)`}>
        <div className="flex shrink:0">
          <div className={`flex ml:auto ${styles.wrapper}`}>
            {/* only show on screen sizes where we show the right panel */}
            <MediaQuery query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`}>
              <MediaQuery query={`(min-width: ${SMALL_DESKTOP_MAX_WIDTH}px)`}>
                <ViewerInsightsForNonEditors />
                <ViewerInsightsButton user={user} />
              </MediaQuery>
              {!isLoggedIn && (
                <MediaQuery query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`}>
                  <div className="flex items:center">
                    <Spacer right="medium">
                      <IconButton {...downloadProps} />
                    </Spacer>
                  </div>
                </MediaQuery>
              )}
              <ShareButtonsWrapper
                className="relative"
                currentUserIsOwner={currentUserIsOwner}
                shareModalShouldOpenAsDropdown
                user={user}
                video={video}
                videoIsTeamShared={videoIsTeamShared}
              />
              <div className="ml:small flex items:center">
                <OverflowMenu
                  downloadUrl={downloadUrl}
                  triggerFocusTitle={triggerFocusTitle}
                  video={video}
                  isLoggedIn={isLoggedIn}
                />
              </div>
            </MediaQuery>
          </div>
        </div>
      </MediaQuery>
    </HeaderPortal>
  );
};
